import { grey000 } from "styles";

export const styles = {
  errorPage: {
    padding: "16px",

    "@media (max-width: 600px)": {
      background: grey000,
    },
  },
  children: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: { xs: "85%", sm: "60%", md: "85%" },

    zIndex: 1,
  },
  content: {
    width: { xs: "100%", md: "50%" },
  },
  mobileImg: {
    display: { xs: "block", md: "none" },
    width: "100%",
    marginBottom: 3,
  },
  desktopImg: {
    display: { xs: "none", md: "block" },
    width: "40%",
  },
  textOverflow: {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 7,
    overflowWrap: "anywhere",
  },
};
